/**
 * O guia de boas-vindas (/bem-vindo, desenho fechado em 28/10/2026:
 * docs/propostas/entrada/boas-vindas.html).
 *
 * Quem decide se a pessoa passa pelo guia é a API, no `Auth/Me` (`boasVindas`):
 * só o administrador que criou a conta, em empresa criada depois do lançamento,
 * e enquanto não houver a marca de "concluído" ou "pulado". Quem já usa o
 * sistema e quem é convidado recebem "nao-se-aplica" e nunca o veem.
 */
export type EstadoBoasVindas = 'pendente' | 'concluido' | 'pulado' | 'nao-se-aplica';

const lerUsuario = (): Record<string, unknown> | null => {
    try {
        return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
        return null;
    }
};

export const estadoBoasVindas = (): EstadoBoasVindas => {
    const estado = lerUsuario()?.boasVindas;
    return estado === 'pendente' || estado === 'concluido' || estado === 'pulado' ? estado : 'nao-se-aplica';
};

/**
 * A porta de entrada do app, depois de entrar: a **Home**, no computador e no celular.
 *
 * Até 29/10/2026 o celular caía na Pipeline ("é onde o trabalho acontece na tela
 * pequena"); ele pediu a Home nos dois, para quem entra ver o mesmo começo de dia
 * em qualquer aparelho. A Home não exige permissão nenhuma, então serve a todo perfil.
 */
export const destinoDentroDoApp = (): string => '/home';

/** Para onde ir logo depois de entrar (login ou cadastro): o guia, se ainda falta; senão, o app. */
export const destinoAposEntrar = (): string =>
    estadoBoasVindas() === 'pendente' ? '/bem-vindo' : destinoDentroDoApp();

/**
 * Espelha no `user` do navegador a marca que acabou de ir para o servidor, para o
 * próximo `destinoAposEntrar()` não mandar de volta ao guia antes de um novo `Auth/Me`.
 */
export const marcarBoasVindasNoNavegador = (estado: 'concluido' | 'pulado'): void => {
    const usuario = lerUsuario();
    if (!usuario) return;
    try {
        localStorage.setItem('user', JSON.stringify({ ...usuario, boasVindas: estado }));
    } catch {
        /* sem storage: o servidor já tem a marca, e é ele quem decide no próximo login */
    }
};
